import React, { useContext } from "react";
import { Link, NavLink } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import Dashboard from "../../assets/images/sidebar_icon1.svg";
import customer from "../../assets/images/customer.png";
import notificationManager from "../../assets/images/Notification-manager.svg";
import transactionManager from "../../assets/images/transaction-manager.svg"
import Logout from "../../assets/images/logout.svg";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import Earning from "../../assets/images/earning_manager.png";
import helpers from "utils/helpers";
import AnimatedComponent from "components/reusable/AnimatedComponent";
import { TbCar } from "react-icons/tb";
import { BsFillMegaphoneFill } from "react-icons/bs";

const classNames = require("classnames");

const Sidebar = () => {
  const { t } = useTranslation();
  const { logoutUser, user, sidebarStatus, updatePageName } = useContext(AuthContext);

  const generateNavLink = (to, label, icon) => (
    <NavLink
      to={to}
      className={({ isActive }) =>
        classNames("flex items-center px-4 lg:px-7 py-4 hover:bg-sideBarNavActiveColor hover:text-gradientTo", {
          "bg-white": isActive,
          "text-black": isActive,
          active: isActive,
        })
      }
      onClick={() => updatePageName(t(label))}
    >
      {icon && <span className="mr-2">{icon}</span>}
      {t(label)}
    </NavLink>
  );

  const handleLogout = () => {
    Swal.fire({
      html:`<b>${t("LOGOUT_MESSAGE")}</b>`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        logoutUser();
      }
    });
  };

  const checkSidebarPermission = (arg) => {
    return true

  };

  const andOperator = (condition, text) => {
    return condition && text;
  };

  const SidebarNavItem = ({ permission, path, label, imgSrc, icon,style }) => {
    const navLink = generateNavLink(path, label, helpers.orOperator(icon, <img src={imgSrc} className="max-w-[18px] filter-bright-invert" style={style} title={t(label)} alt="" />));

    return andOperator(checkSidebarPermission(permission), navLink);
  };

  return (
    <div className={`sidebar lg:block z-10   ${sidebarStatus === "open" ? "block" : "sidebarHide"} bg-gradientTo w-[220px] xl:w-[280px] fixed h-full overflow-y-auto`}>
      <div className="text-sideBarNavColor">
        <Link to="/dashboard" onClick={() => updatePageName("Dashboard")} className={` w-full text-center mt-6 mb-4 flex justify-center bg-black ${sidebarStatus === "open" ? "showToggle" : ""}`}>
          <img src={"/images/fasttow.png"} className="inline max-w-[133px]" alt="" />
        </Link>
        <div className="profile text-center">
          <small className="block text-sm">Welcome</small>
          <strong className="block text-lg overflow-hidden text-ellipsis px-2 whitespace-nowrap ">{user?.firstName + " " + user?.lastName}</strong>
        </div>
        <AnimatedComponent>
          <nav className="pt-4 pb-5 flex flex-col justify-center font-normal text-xs overflow-y-auto">
            <SidebarNavItem path="/dashboard" label="NAV_DASHBOARD" imgSrc={Dashboard} />
            <SidebarNavItem permission="customer-manager" path="/driver-manager" label="DRIVER_MANAGER" imgSrc={customer} />
            <SidebarNavItem permission="vehicle-manager" path="/vehicle-manager" label="VEHICLE_MANAGER" icon={<TbCar size={20}  />}/>
            <SidebarNavItem permission="service-price-manager" path="/service-price-manager" label="SERVICE_PRICE_MANAGER" imgSrc={Earning}/>
            <SidebarNavItem permission="transaction-manager" path="/transaction-manager" label="TRANSACTION_MANAGER" imgSrc={transactionManager} />
            <SidebarNavItem permission="earning-manager" path="/earning-manager" label="EARNING_MANAGER" imgSrc={'/images/earning_manager.svg'} />
            <SidebarNavItem permission="feedback-manager" path="/feedback-manager" label="FEEDBACK_MANAGER" imgSrc={transactionManager} />
            <SidebarNavItem permission="service-monitoring" path="/service-monitoring" label="SERVICE_MANAGER" imgSrc={'/images/service_monitoring_1.svg'} />
            <SidebarNavItem permission="notification-manager" path="/notification-manager" label="NOTIFICATION_MANAGER" imgSrc={notificationManager} />
            <SidebarNavItem permission="announcement-manager" path="/announcement-manager" label="ANNOUNCEMENT_MANAGER" icon={<BsFillMegaphoneFill size={15}/>} />
            <SidebarNavItem permission="help-and-support" path="/help-and-support" label="HELP_AND_SUPPORT" imgSrc={'/images/support.svg'} style={{filter: 'grayscale(1)'}}/>
            <Link onClick={handleLogout} className="flex items-center px-4 lg:px-7 py-4 hover:bg-sideBarNavActiveColor hover:text-gradientTo">
              <span className="mr-2">
                <img src={Logout} className="max-w-[18px]" title={t("NAV_LOGOUT")} alt="logout" />
              </span>
              {t("NAV_LOGOUT")}
            </Link>
          </nav>
        </AnimatedComponent>
      </div>
    </div>
  );
};

export default Sidebar;
